exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body,html{margin:0;padding:0}body{font-size:16px;font-family:Arial,sans-serif;color:#232321;background:#fff!important}#app,body,html{height:100%;width:100%;box-sizing:border-box}#app{overflow:auto}*{margin:0;padding:0}", ""]);

// exports
